// Load all the controllers within this directory and all subdirectories.
// Controller files must be named *_controller.js.

import { Application } from "@hotwired/stimulus"
import StimulusControllerResolver, { createViteGlobResolver } from 'stimulus-controller-resolver'

import BulmaFileInputController from "~/controllers/bulma/file_input_controller"
import BulmaNavbarController from "~/controllers/bulma/navbar_controller"
import BulmaCopyButtonController from "~/controllers/bulma/copy_button_controller"
import BulmaDateFieldController from "~/controllers/bulma/date_field_controller"
import TrixFileAttachmentsController from "~/controllers/trix/file_attachments_controller"
import TrixYoutubeAttachmentsController from "~/controllers/trix/youtube_attachments_controller"
import ShoelaceToastController from "~/controllers/shoelace/toast_controller"

const application = Application.start()

application.register("bulma--file-input", BulmaFileInputController)
application.register("bulma--navbar", BulmaNavbarController)
application.register("bulma--copy-button", BulmaCopyButtonController)
application.register("bulma--date-field", BulmaDateFieldController)
application.register("trix--file-attachments", TrixFileAttachmentsController)
application.register("trix--youtube-attachments", TrixYoutubeAttachmentsController)
application.register("shoelace--toast", ShoelaceToastController)

StimulusControllerResolver.install(application, createViteGlobResolver({
  glob: import.meta.glob('./*_controller.js'),
  regex: /^(?:.*?(?:controllers)\/|\.?\.\/)?(.+?)(?:[_-]controller\..+?)$/
}))
